import { useSolicitacaoQuery, useMovimentacoesQuery } from '../../../hooks/data';
import type { Movimentacao } from '../../../models';

interface DestinoColaboradorInfoProps {
  solicitacaoId: string;
  movimentacaoId: string;
}

function formatarData(timestamp: Movimentacao['dataEnvio']): string | null {
  if (!timestamp) return null;
  const data = 'toDate' in timestamp ? timestamp.toDate() : new Date(timestamp as unknown as string);
  return data.toLocaleDateString('pt-BR');
}

/**
 * Resolve e mostra pra quem a estadia foi (Fase 2 — virou Movimentação real) — nome do
 * colaborador e as datas de envio/recebimento REAIS, que vivem só na Movimentação (não
 * duplicadas na Estadia, ver EstadiaCliente.solicitacaoRealId/movimentacaoRealId). Só
 * leitura, mesmo espírito de HistoricoEstadiasEquipamentoSection.
 */
export default function DestinoColaboradorInfo({ solicitacaoId, movimentacaoId }: DestinoColaboradorInfoProps) {
  const { data: solicitacao } = useSolicitacaoQuery(solicitacaoId);
  const { data: movimentacoes = [] } = useMovimentacoesQuery(solicitacaoId);
  const movimentacao = movimentacoes.find((item) => item.id === movimentacaoId);

  return (
    <p className="text-sm text-gray-500">
      <span className="font-semibold text-gray-900">Enviada direto ao colaborador:</span>{' '}
      {solicitacao?.colaboradorNome ?? '—'}
      {movimentacao && (
        <>
          {' · '}
          <span className="font-semibold text-gray-900">Enviada em:</span>{' '}
          {formatarData(movimentacao.dataEnvio) ?? 'a definir'} ·{' '}
          <span className="font-semibold text-gray-900">Recebida em:</span>{' '}
          {formatarData(movimentacao.dataRecebimento) ?? 'a definir'}
        </>
      )}
    </p>
  );
}
